( function() {
	'use strict';

	// Powers any `.site-ribbon-countdown` elements injected via the
	// {{countdown_timer}} placeholder in the Site Ribbon (see
	// global-templates/site-ribbon.php). No jQuery dependency so this keeps
	// working even if the ribbon markup ends up somewhere jQuery isn't loaded.
	function init_countdowns() {
		var countdowns = document.querySelectorAll( '.site-ribbon-countdown[data-countdown-target]' );

		countdowns.forEach( function( countdown ) {
			var target = new Date( countdown.getAttribute( 'data-countdown-target' ) );

			if ( isNaN( target.getTime() ) ) {
				return;
			}

			var tick = function() {
				var remaining = target.getTime() - Date.now();

				if ( 0 >= remaining ) {
					clearInterval( interval );
					expire_countdown( countdown );
					return;
				}

				render_countdown( countdown, remaining );
			};

			tick();

			var interval = setInterval( tick, 1000 );
		} );
	}

	// Update the day/hour/minute/second segments to reflect the time remaining
	function render_countdown( countdown, remaining ) {
		var second = 1000;
		var minute = second * 60;
		var hour   = minute * 60;
		var day    = hour * 24;

		var values = {
			days:    Math.floor( remaining / day ),
			hours:   Math.floor( ( remaining % day ) / hour ),
			minutes: Math.floor( ( remaining % hour ) / minute ),
			seconds: Math.floor( ( remaining % minute ) / second ),
		};

		Object.keys( values ).forEach( function( unit ) {
			var $value = countdown.querySelector( '[data-countdown-unit="' + unit + '"]' );

			if ( $value ) {
				$value.textContent = ( '0' + values[ unit ] ).slice( -2 );
			}
		} );
	}

	// Once the target time has passed, either swap in the configured expired
	// text or just remove the timer entirely
	function expire_countdown( countdown ) {
		var expired_text = countdown.getAttribute( 'data-countdown-expired-text' );

		if ( expired_text ) {
			countdown.textContent = expired_text;
		} else {
			countdown.remove();
		}
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init_countdowns );
	} else {
		init_countdowns();
	}
} )();
